import { BackofficeUserModel } from 'api/backofficeApiClient';
import { getFullName } from 'utils/personUtils';
import { isAdminRole } from 'utils/userRolesUtils';
import { UserRole } from '../enums';

export const startVisitorLiveChat = () => {
  window.Intercom('shutdown');
  window.Intercom('boot', {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  });
};

export const startUserLiveChat = (user: BackofficeUserModel, activeRole?: UserRole | null) => {
  window.Intercom('shutdown');
  const isAdmin = isAdminRole({ user, activeRole });

  if (isAdmin) return;

  const { email, userId, firstName, lastName, userHash } = user;
  const name = getFullName(firstName, lastName);

  window.Intercom('boot', {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    email,
    user_id: userId,
    name,
    user_hash: userHash,
  });
};
